import React, { useState } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  togglePerformanceSpeedLimit,
  togglePerformancePriority,
  togglePerformanceSpeed,
  toggleSkipDiskErr
} from "store/actions";
import {
  formatBitesPerSec,
  objectToArray,
  forbidExtraProps,
  outlineFocus
} from "utils";
import { CONTENT, STATIC_URLS } from "consts";
import { config } from "config";

function Performance(props) {
  const speedTabs = [
    { key: "Mbps", value: "Mbps" },
    { key: "Kbps", value: "Kbps" }
  ];
  const [currentTab, setCurrentTab] = useState(
    props.performance.speed.value === 0
      ? "Mbps"
      : formatBitesPerSec(props.performance.speed.value).split(" ")[1]
  );

  function toggleSpeedUnit(unit) {
    setCurrentTab(unit);
    props.togglePerformanceSpeed(
      formatBitesPerSec(props.performance.speed.value).split(" ")[0],
      unit
    );
  }

  return (
    <>
      <div className="advance_performance">
        <div className="sub_title">
          <p>Performance</p>
        </div>
        <div className="performance_item flex_align">
          <p>
            {CONTENT.backupSettings.advance.performance.backupPriority.part1}{" "}
          </p>
          <div className="main_select" style={{ margin: "0 10px" }}>
            <select
              onChange={e => props.togglePerformancePriority(e.target.value)}
              value={props.performance.priority}
            >
              {objectToArray(props.performancePriorityEnums.props).map(
                (val, i) => (
                  <option
                    value={props.performancePriorityEnums[val.key]}
                    key={i}
                  >
                    {val.name.charAt(0).toUpperCase() + val.name.slice(1)}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
        <div className="performance_item">
          <p>
            {CONTENT.backupSettings.advance.performance.networkSpeed.part1}{" "}
          </p>
          <div className="performance_limit flex_align mob_flex_col">
            <div className="limit_item">
              <label className="radio_container">
                <input
                  type="radio"
                  className="input_radio"
                  name="limit_performance_radio"
                  defaultChecked={!props.performance.speed.limit}
                  onChange={() => props.togglePerformanceSpeedLimit()}
                  onFocus={() => {
                    outlineFocus("radio_checkmark_limit", 1);
                  }}
                  onBlur={() => {
                    outlineFocus("radio_checkmark_limit", 0);
                  }}
                />
                <span className="radio_checkmark" id="radio_checkmark_limit" />
                <span>Don't Limit</span>
              </label>
            </div>
            <div className="limit_item flex_align">
              <label className="radio_container">
                <input
                  type="radio"
                  className="input_radio"
                  name="limit_performance_radio"
                  defaultChecked={props.performance.speed.limit}
                  onChange={() => props.togglePerformanceSpeedLimit()}
                />
                <span className="radio_checkmark" /> <span>Limit To</span>{" "}
              </label>
              <div
                className={[
                  "limit_speed transparent_layer_wrap transparent_layer_limit",
                  props.performance.speed.limit === 1 ? "layer_active" : ""
                ].join(" ")}
              >
                <div className="transparent_layer" />
                <input
                  type="number"
                  className="input_number"
                  value={
                    formatBitesPerSec(props.performance.speed.value).split(
                      " "
                    )[0]
                  }
                  onChange={e =>
                    props.togglePerformanceSpeed(e.target.value, currentTab)
                  }
                />
                <div className="limit_speed_tail">
                  <div className="main_select">
                    <select
                      onChange={e => toggleSpeedUnit(e.target.value)}
                      value={currentTab}
                    >
                      {speedTabs.map(val => (
                        <option value={val.key} key={val.key}>
                          {val.value}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="advance_cleanup crc_settings">
        <div className="sub_title">
          <p>Error Handling </p>
        </div>
        <div className="cleanup_item last_child_bottom">
          <div className="checkbox_wrapper just_flex">
            <div className="check">
              <input
                type="checkbox"
                defaultChecked={props.performance.ignoreBadSectors === 1}
                onChange={e => {
                  props.toggleSkipDiskErr(e.target.checked ? 1 : 0);
                }}
                className="input_checkbox"
                id="delete_versions_2"
              />
              <label
                for="delete_versions_2"
                id="delete_versions_2_label"
              ></label>
            </div>
            <div
              className="just_flex checkbox_p "
              onClick={() => {
                props.toggleSkipDiskErr(
                  props.performance.ignoreBadSectors === 1 ? 0 : 1
                );
              }}
            >
              <p>{CONTENT.backupSettings.advance.skipDiskErr.checkLabel}</p>
              <span></span>
            </div>
          </div>
          <div class="next_schedule_msg">
            <p>
              <strong>Note: </strong>
              {CONTENT.backupSettings.advance.skipDiskErr.checkNote}{" "}
              <a
                href={
                  STATIC_URLS.diskFaq[
                    props?.origin === "idrive" ? "idrive" : config.APP_INSTANCE
                  ]
                }
                target="_blank"
              >
                Know more.
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

Performance.propTypes = forbidExtraProps(
  {
    performance: PropTypes.object.isRequired,
    performancePriorityEnums: PropTypes.object.isRequired
  },
  [
    "togglePerformanceSpeedLimit",
    "togglePerformancePriority",
    "togglePerformanceSpeed",
    "toggleSkipDiskErr"
  ]
);

function mapStateToProps(state) {
  return {
    performance: state.backupSettings.performance,
    performancePriorityEnums: state.common.enums.PerformancePriority,
    origin: state.account.origin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      togglePerformanceSpeedLimit,
      togglePerformancePriority,
      togglePerformanceSpeed,
      toggleSkipDiskErr
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Performance);
